import { jsx } from 'react/jsx-runtime';
import { useRef, useLayoutEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { DefaultNode } from './DefaultNode.esm.js';
import { NODE_TEST_ID } from './constants.esm.js';

const useStyles = makeStyles(
  (theme) => ({
    node: {
      transition: `${theme.transitions.duration.shortest}ms`
    }
  }),
  { name: "BackstageDependencyGraphNode" }
);
const renderDefault = (props) => /* @__PURE__ */ jsx(DefaultNode, { ...props });
function Node({
  render = renderDefault,
  setNode,
  node
}) {
  const { width, height, x = 0, y = 0 } = node;
  const nodeProps = node;
  const classes = useStyles();
  const nodeRef = useRef(null);
  useLayoutEffect(() => {
    if (nodeRef.current) {
      let { height: renderedHeight, width: renderedWidth } = nodeRef.current.getBBox();
      renderedHeight = Math.round(renderedHeight);
      renderedWidth = Math.round(renderedWidth);
      if (renderedHeight !== height || renderedWidth !== width) {
        setNode(node.id, {
          ...node,
          height: renderedHeight,
          width: renderedWidth
        });
      }
    }
  }, [node, width, height, setNode]);
  return /* @__PURE__ */ jsx(
    "g",
    {
      ref: nodeRef,
      "data-testid": NODE_TEST_ID,
      className: classes.node,
      transform: `translate(${x - width / 2},${y - height / 2})`,
      children: render({ node: nodeProps })
    }
  );
}

export { Node };
//# sourceMappingURL=Node.esm.js.map
